<template>
  <div class="phone-modal-overlay" @click.self="$emit('close')">
    <div class="phone-modal">
      <button class="close-btn" @click="$emit('close')">✕</button>
      <h2 class="modal-title">Give Us a Call!</h2>
      <p class="modal-subtitle">Choose your nearest location:</p>

      <div class="location-buttons">
        <a href="tel:269-262-5055" class="location-btn southwest">
          <span class="location-label">Southwest Michigan</span>
          <span class="location-number">269-262-5055</span>
        </a>
        <a href="tel:989-858-3559" class="location-btn northern">
          <span class="location-label">Northern Michigan</span>
          <span class="location-number">989-858-3559</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneModal',
  emits: ['close'],
}
</script>

<style scoped>
.phone-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.phone-modal {
  background: linear-gradient(135deg, #002655 0%, #1a3a5c 60%, #4a7ba7 100%);
  border-radius: 16px;
  padding: 40px 32px 32px;
  width: 90%;
  max-width: 420px;
  position: relative;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
  text-align: center;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  color: rgba(255,255,255,0.7);
  font-size: 1.4rem;
  cursor: pointer;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #f1c40f;
}

.modal-title {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 8px;
}

.modal-subtitle {
  color: rgba(255,255,255,0.75);
  font-size: 1rem;
  margin: 0 0 28px;
}

.location-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.location-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 24px;
  border-radius: 12px;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.location-btn:hover {
  transform: translateY(-3px);
}

.southwest {
  background: linear-gradient(135deg, #8d0808 0%, #b91010 100%);
  box-shadow: 0 4px 16px rgba(141, 8, 8, 0.4);
}
.southwest:hover {
  box-shadow: 0 6px 20px rgba(141, 8, 8, 0.6);
}

.northern {
  background: linear-gradient(135deg, #1a6b3a 0%, #27a158 100%);
  box-shadow: 0 4px 16px rgba(26, 107, 58, 0.4);
}
.northern:hover {
  box-shadow: 0 6px 20px rgba(26, 107, 58, 0.6);
}

.location-label {
  color: rgba(255,255,255,0.85);
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.location-number {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
